import { useState, ReactNode } from 'react';

import { useIntl } from 'react-intl';
import { Button, Modal } from 'react-bootstrap';

import { FilterIcon } from 'assets/icons';

interface IFiltersPanelProps {
  children: ReactNode;
  disableApply: boolean;
  clearable: boolean;
  onApply: () => any;
  onClear: () => any;
  onClose: () => any;
  hasMargins: boolean;
  filtersCount: number;
  dataTestIdPrefix?: string;
}

const FiltersPanel = ({
  children,
  disableApply,
  clearable,
  onApply,
  onClear,
  onClose,
  hasMargins = true,
  filtersCount,
  dataTestIdPrefix
}: IFiltersPanelProps) => {
  const [show, setShow] = useState(false);
  const intl = useIntl();

  const handleApply = () => {
    onApply();
    setShow(false);
  };

  const handleClose = () => {
    setShow(false);
    onClose();
  };

  const handleClear = () => {
    onClear();
    filtersCount > 0 && setShow(false);
  };

  const handleOpen = () => {
    setShow(true);
  };

  return (
    <>
      <Button
        variant="link"
        data-test={`${dataTestIdPrefix ? dataTestIdPrefix + '-' : ''}filtersPanelButton`}
        onClick={handleOpen}
        className={`${hasMargins ? 'mt-2' : ''} align-self-start me-2 ps-0`}
      >
        <FilterIcon className="icon align-middle" />
        <span className="align-middle">{intl.formatMessage({ id: 'filtersKey' })}</span>
      </Button>
      <Modal
        show={show}
        onHide={handleClose}
        scrollable
        dialogClassName="filtersPanel"
        contentClassName="filtersPanelContent"
      >
        <Modal.Header className="align-items-center">
          <Modal.Title>{intl.formatMessage({ id: 'filtersKey' })}</Modal.Title>
          <Button
            className="ms-2"
            variant="light"
            data-test={`${dataTestIdPrefix ? dataTestIdPrefix + '-' : ''}clearFiltersPanelButton`}
            onClick={handleClear}
            disabled={!clearable}
          >
            {intl.formatMessage({ id: 'clearKey' })}
          </Button>
        </Modal.Header>
        <Modal.Body data-test={`${dataTestIdPrefix ? dataTestIdPrefix + '-' : ''}filtersPanelBody`}>
          {children}
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button
            variant="link"
            data-test={`${dataTestIdPrefix ? dataTestIdPrefix + '-' : ''}closeFiltersPanelButton`}
            onClick={handleClose}
          >
            {intl.formatMessage({ id: 'closeKey' })}
          </Button>
          <Button
            variant="primary"
            data-test={`${dataTestIdPrefix ? dataTestIdPrefix + '-' : ''}applyFiltersPanelButton`}
            onClick={handleApply}
            disabled={disableApply}
          >
            {intl.formatMessage({ id: 'applyKey' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FiltersPanel;
